module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.8374b555.woff2";